import React, { FC, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Row, Col } from "antd";
import { useHandleForm } from "../../../hooks/useHandleForm";
import {
  AutoComplete,
  FormBlock,
  FormField,
  FormInterval,
  IButton,
  IDatePicker,
  ISelect,
} from "../../../ui-kit";
import DictionariesStore from "../../../store/dictionary";
import { useStatusMessage } from "../../../hooks/useStatusMessage";

import styles from "../styles.module.scss";


const DictionaryItemEditForm: FC = observer((values) => {
  const initialValues = {
    id:  values?.record?.id,
    dictionaryValue: values?.record?.dictionaryValue,
    shortDictionaryValue: values?.record?.shortDictionaryValue,
    customDictionaryId: values?.record?.customDictionaryId
  };
  const initialFocus = {};
  const {
    register,
    handleSubmit,
    watchAllField,
    isFocused,
    handleBlur,
    handleFocus,
    control,
    setValue,
  } = useHandleForm(null, initialValues, initialFocus);

  const onSubmit = (values) => {
    DictionariesStore.saveDictItem(values)
  };
  console.log(values)
  return (
    <form
      className={styles.SmsSettingsParamsForm}
      onSubmit={handleSubmit(onSubmit)}
    >
      <FormBlock>
        <Row gutter={[15, 20]}>
          {
            (values.hasShortDictionaryValue || values?.record?.customDictionaryId == 900202) &&
            <Col span={8}>            
              <FormField
                label="Код"
                name="shortDictionaryValue"
                register={register}
                type="text"
                isFocused={isFocused.shortDictionaryValue}
                currentValue={watchAllField.shortDictionaryValue}
                onFocus={handleFocus}
                onBlur={handleBlur}
                isRequired
              />
            </Col>
          }  
          <Col span={8}>
            <FormField
              label="Значение справочника"
              name="dictionaryValue"
              register={register}
              type="text"
              isFocused={isFocused.dictionaryValue}
              currentValue={watchAllField.dictionaryValue}
              onFocus={handleFocus}
              onBlur={handleBlur}
              isRequired
            />
          </Col>        
          <Col span={24} className="form-block__data-header">
            <IButton className={styles.UsersButton} type="submit">
              Сохранить
            </IButton>
          </Col>
        </Row>
      </FormBlock>
    </form>
  );
});

export default DictionaryItemEditForm;
